module.exports = __webpack_public_path__ + "img/20190725161836948.6710de7f.png";